
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import CardNotTicket from "@/components/card/CardNotTicket.vue";
import ModalLinkProgressChat from "@/components/modal/ModalLinkProgressChat.vue";
import ModalLinkAction from "@/components/modal/ModalLinkAction.vue";
import { Component, Ref } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import DraggableCal from "vue-draggable-cal";
import TicketModel from "@/models/createTicket/TicketModel";
import GroupModel from "@/models/GroupModel";
import { UserModule } from "@/store/modules/user";
import utils from "@/utils";
import api from "@/api";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import FilterModel from "@/models/FilterModel";
// import moment from "moment";
// import { Emit, Model } from "vue-property-decorator";
@Component({
  components: {
    SubHeader,
    Search,
    MenuFooter,
    ModalLinkProgressChat,
    ModalLinkAction,
    CardNotTicket,
    DraggableCal,
    VueperSlides,
    VueperSlide,
  },
})
export default class ListTicket extends Vue {
  mounted() {
    this.loadTicketSearch(this.$route.params.search);
    // if (this.$route.name === "ticket-search") {
    //   this.loadTicketSearch(this.$route.params.search);
    // } else {
    //   // this.loadTicket();
    //   this.getTicketByDate(moment().format("YYYY-MM-DD"));
    // }
  }
  utils = utils;
  userDetail = UserModule.userDetail;
  titlePage = this.userDetail.accessgroup["name"] === "User" ? "Ticket" : "Work Order";
  subTitleSmallPage = this.userDetail.accessgroup["name"] === "User" ? "Open Ticket History" : "Open Work Order History";
  lenghtClosed = 0;
  lenghtTicket = 0;
  displayLoading = true;
  displayTicket = false;

  currentPage = 1;
  hasMorePages = false;
  isLoading = false;

  listTicket: TicketModel[] = [];
  groupUser: GroupModel = new GroupModel();

  @Ref() modalLink!: ModalLinkProgressChat;
  @Ref() modalLink1!: ModalLinkAction;

  loadTicket() {
    this.displayLoading = true;
    return new Promise((resolve, reject) => {
      if (this.userDetail.accessgroup["name"] === "Operator") {
        api.ticket
          .getMyTask2()
          .then((response) => {
            if (response.data.code === 200) {
              this.listTicket = [...response.data.data].map((e) => ({closed : e.tiket_status == 'Closed'  || e.tiket_status == 'Rejected'  || e.status == 'Technical completion' ,...e}));
              this.lenghtTicket = this.listTicket.filter(
                (item) => !item.closed
              ).length;
              this.lenghtClosed = this.listTicket.filter(
                (item) => item.closed
              ).length;
              this.displayLoading = false;
              this.displayTicket = true;
              resolve(response);
            }
          })
          .catch((err: any) => {
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      } else {
        api.ticket
          .getMyTicket2()
          .then((response) => {
            if (response.data.code === 200) {
              this.listTicket = [...response.data.data.data].map((e) => ({closed : e.tiket_status == 'Closed'  || e.tiket_status == 'Rejected'  || e.status == 'Technical completion' ,...e}));
              this.lenghtTicket = this.listTicket.filter(
                (item) => !item.closed
              ).length;
              this.lenghtClosed = this.listTicket.filter(
                (item) => item.closed
              ).length;
              this.displayLoading = false;
              this.displayTicket = true;
              resolve(response);
            }
          })
          .catch((err: any) => {
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      }
    });
  }
  loadTicketSearch(search: string | null) {
    this.displayLoading = true;
    return new Promise((resolve, reject) => {
      if (this.userDetail.accessgroup["name"] !== "User") {
        api.ticket
          .getMyTaskSearch2(search, this.currentPage)
          .then((response) => {
            if (response.data.code === 200) {
              const newTickets = [...response.data.data].map((e) => ({
                closed: e.tiket_status == 'Closed' || e.tiket_status == 'Rejected' || e.status == 'Technical completion',
                ...e
              }));
              
              if (this.currentPage === 1) {
                this.listTicket = newTickets;
              } else {
                this.listTicket = [...this.listTicket, ...newTickets];
              }

              this.hasMorePages = response.data.meta.current_page < response.data.meta.last_page;
              this.lenghtTicket = this.listTicket.filter(item => !item.closed).length;
              this.lenghtClosed = this.listTicket.filter(item => item.closed).length;
              this.displayLoading = false;
              this.displayTicket = true;
              this.isLoading = false;
              resolve(response);
            }
            
          })
          .catch((err) => {
            this.isLoading = false;
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      } else {
        api.ticket
          .getMyTicketSearch2(search, this.currentPage)
          .then((response) => {
            if (response.data.code === 200) {
              const newTickets = [...response.data.data.data].map((e) => ({
                closed: e.tiket_status == 'Closed' || e.tiket_status == 'Rejected' || e.status == 'Technical completion',
                ...e
              }));
              
              if (this.currentPage === 1) {
                this.listTicket = newTickets;
              } else {
                this.listTicket = [...this.listTicket, ...newTickets];
              }

              this.hasMorePages = response.data.data.current_page < response.data.data.last_page;
              this.lenghtTicket = this.listTicket.filter(item => !item.closed).length;
              this.lenghtClosed = this.listTicket.filter(item => item.closed).length;
              this.displayLoading = false;
              this.displayTicket = true;
              this.isLoading = false;
              
              resolve(response);
            }
            console.log(response.data.data.last_page)
          })
          .catch((err) => {
            this.isLoading = false;
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      }
    });
  }
  loadTicketFilter(filter: FilterModel) {
    this.displayLoading = true;
    return new Promise((resolve, reject) => {
      if (this.userDetail.accessgroup["name"] !== "User") {
        api.ticket
          .getMyTaskFilter2(filter)
          .then((response) => {
            if (response.data.code === 200) {
              this.listTicket = [...response.data.data].map((e) => ({closed : e.tiket_status == 'Closed'  || e.tiket_status == 'Rejected'  || e.status == 'Technical completion' ,...e}));
              this.lenghtTicket = this.listTicket.filter(
                (item) => !item.closed
              ).length;
              this.lenghtClosed = this.listTicket.filter(
                (item) => item.closed
              ).length;
              filter = new FilterModel();
              this.displayLoading = false;
              this.displayTicket = true;
              resolve(response);
            }
          })
          .catch((err: any) => {
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      } else {
        api.ticket
          .getMyTicketFilter2(filter)
          .then((response) => {
            if (response.data.code === 200) {
              this.listTicket = [...response.data.data.data].map((e) => ({closed : e.tiket_status == 'Closed'  || e.tiket_status == 'Rejected'  || e.status == 'Technical completion' ,...e}));
              this.lenghtTicket = this.listTicket.filter(
                (item) => !item.closed
              ).length;
              this.lenghtClosed = this.listTicket.filter(
                (item) => item.closed
              ).length;
              filter = new FilterModel();
              this.displayLoading = false;
              this.displayTicket = true;
              resolve(response);
            }
          })
          .catch((err: any) => {
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      }
    });
  }
  loadMore() {
    if (!this.isLoading && this.hasMorePages) {
      this.isLoading = true;
      this.currentPage++;
      this.loadTicketSearch(this.$route.params.search);
    }
  }
  onClickSubmitSearch(value: string | null) {
    this.currentPage = 1;
    this.loadTicketSearch(value);
  }
  onFilter(filter: FilterModel) {
    this.currentPage = 1;
    this.loadTicketFilter(filter);
  }
  getTicketByDate(date: string | null) {
    this.displayLoading = true;
    this.displayTicket = false;
    return new Promise((resolve, reject) => {
      if (this.userDetail.accessgroup["name"] === "Operator") {
        api.ticket
          .getMyTaskByDate2(date)
          .then((response) => {
            if (response.data.code === 200) {
              this.listTicket = [...response.data.data].map((e) => ({closed : e.tiket_status == 'Closed'  || e.tiket_status == 'Rejected'  || e.status == 'Technical completion' ,...e}));
              this.lenghtTicket = this.listTicket.filter(
                (item) => !item.closed
              ).length;
              this.lenghtClosed = this.listTicket.filter(
                (item) => item.closed
              ).length;
              this.displayLoading = false;
              this.displayTicket = true;
              resolve(response);
            }
          })
          .catch((err: any) => {
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      } else {
        api.ticket
          .getMyTicketByDate2(date)
          .then((response) => {
            if (response.data.code === 200) {
              this.listTicket = [...response.data.data.data].map((e) => ({closed : e.tiket_status == 'Closed'  || e.tiket_status == 'Rejected'  || e.status == 'Technical completion' ,...e}));
              this.lenghtTicket = this.listTicket.filter(
                (item) => !item.closed
              ).length;
              this.lenghtClosed = this.listTicket.filter(
                (item) => item.closed
              ).length;
              this.displayLoading = false;
              this.displayTicket = true;
              resolve(response);
            }
          })
          .catch((err: any) => {
            reject(err);
            this.$swal("Error", err?.response?.data?.message, "error");
          });
      }
    });
  }

  showModal(ticket: any, activemenu: Activemenumodel) {
    // console.log(ticket);
    // if(['Operator','Operator Maintenance','Operator Project'].includes(this.userDetail.accessgroup['name'])){
      this.modalLink1.showModal(ticket, activemenu);
    // if(['Supervisor'].includes(this.userDetail.accessgroup['name'])){
    //   this.modalLink1.showModal(idTicket);
    // }else{
    //   this.modalLink.showModal(idTicket);
    // }
  }
  selectedDate(event) {
    const date = this.utils.general.unFormatDate(event);
    this.getTicketByDate(date);
  }
  pitaStatus(statusColor: string | null) {
    let color = "";
    switch (statusColor) {
      case "new":
        color = "new";
        break;
      case "On Progress":
        color = "on-progress";
        break;
      case "In Progress":
        color = "on-progress";
        break;
      default:
        color = "on-progress";
        break;
    }
    return color;
  }
  colorStatus(statusColor: string | null) {
    let color = "";
    switch (statusColor) {
      case "new":
        color = "cl-red";
        break;
      case "On Progress":
        color = "cl-green-light";
        break;
      case "In Progress":
        color = "cl-green-light";
        break;
      case "Rejected":
        color = "cl-red";
        break;
      case "Closed":
        color = "cl-abu-abu";
        break;
      case "Approved":
        color = "cl-green-young";
        break;
      default:
        color = "cl-red";
    }
    return color;
  }
}


class Activemenumodel {
  assesment: number | undefined;
  additional_resource: number | undefined;
  work_order_feedback: number | undefined;
  work_order_history: number | undefined;
  chat: number | undefined;
  work_order_activity: number | undefined;
}
